import { render, staticRenderFns } from "./CatalogoDePuntos.vue?vue&type=template&id=27320bfd&scoped=true"
import script from "./CatalogoDePuntos.vue?vue&type=script&lang=js"
export * from "./CatalogoDePuntos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDePuntos.vue?vue&type=style&index=0&id=27320bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27320bfd",
  null
  
)

export default component.exports